/* Campaign links into a chosen bundle, and now into a chosen FRAME.

   An ad can point at a specific offer:
     /pages/bundles?bundle=2-for-30
     /pages/bundles?bundle=3-for-55
   and the page opens on that tier. The tabs still work, so the shopper can
   move to another offer — the link chooses the starting point, it does not
   lock anything.

   Accepted forms, all case-insensitive:
     the label slug   2-for-30, 3for55, "2 for 40"
     the amount alone 30, 40, 55, 60, 85
     the internal key twoS, two, three, twoP, threeP
   Anything unrecognised is ignored and the page opens normally, because an
   ad link with a typo should still land somewhere sensible.

   ?pick= PRESELECTS A FRAME, and it is what the bundle line on every
   product page uses. Someone reading about one frame, told "2 for 40",
   should arrive with THAT frame already chosen — otherwise the offer sends
   them to a grid of seven hundred frames and asks them to find it again.

   The value is the variant id, which is what the cards carry as data-vid
   and what SF.togglePick expects.

   WHY THIS MOVES THE FRAME TO THE FRONT OF THE POOL.
   The first attempt simply called togglePick once the card appeared, and
   it did nothing visible. The grid renders 48 cards at a time out of 728,
   and there are no separate slot elements — a pick is only ever drawn ON
   its card. If the card has not been paged in, the frame is silently
   selected and the shopper sees an unchanged page, which is worse than not
   selecting at all.

   Paging until the card appeared did work — six rounds for the frame this
   was tested against — but that means rendering three hundred cards on a
   phone to show one, and a frame near the end of the range would render
   seven hundred.

   SF.bundleView is the hook the renderer uses to filter and sort the pool,
   so wrapping it and lifting the chosen frame to index 0 puts it in the
   first row of the first page. It is then both visible and selected, which
   is what the product page promised. The wrapper is transparent otherwise:
   it calls the previous view, keeps its filtering and ordering, and moves
   exactly one item.

   THE WRAP HAS TO HAPPEN BEFORE A RENDER, and this file is the last of the
   bundle scripts, so it wraps whatever sf-bundleorder installed and then
   forces one render of its own.

   IT ALSO CHECKS THE FRAME IS NOT ALREADY PICKED, because togglePick is a
   toggle — calling it twice is the same as not calling it at all.

   The tab the shopper lands on is written back into the address bar, so a
   shared or bookmarked link keeps the offer. */
(function(){
"use strict";
function slug(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') }

function resolve(bundles, want){
  if(!want) return null;
  var w=slug(want), keys=Object.keys(bundles||{}), i, k, b, s;
  /* internal key, exactly as written in the catalogue */
  for(i=0;i<keys.length;i++) if(slug(keys[i])===w) return keys[i];
  /* label slug: "2 for 30 KD" matches 2-for-30 and 2-for-30-kd */
  for(i=0;i<keys.length;i++){
    k=keys[i]; b=bundles[k]; s=slug(b.label);
    if(s===w || s===w+'-kd' || s.replace(/-kd$/,'')===w) return k;
  }
  /* bare amount: 30, 55, 85 */
  if(/^[0-9]+$/.test(w)){
    for(i=0;i<keys.length;i++){
      k=keys[i]; b=bundles[k];
      if(String(b.label).replace(/[^0-9]/g,'').indexOf(w)>-1 && String(Math.round(b.price/1000))===w) return k;
    }
  }
  return null;
}

function param(name){
  var q; try{ q=new URLSearchParams(window.location.search) }catch(e){ return null }
  return q.get(name);
}

function wanted(){ return param('bundle') || param('offer') || param('tier'); }

document.addEventListener('DOMContentLoaded', function(){
  var grid=document.getElementById('bGrid');
  if(!grid || !window.SF) return;
  var data={}; try{ data=JSON.parse((document.getElementById('sf-data')||{}).textContent||'{}') }catch(e){}

  var pick = param('pick');
  if(pick && !/^[0-9]+$/.test(pick)) pick = null;

  /* Lift the chosen frame to the front of whatever the current view is, so
     it lands in the first row instead of somewhere on page seven. */
  if(pick && typeof SF.bundleView === 'function'){
    var prevView = SF.bundleView;
    SF.bundleView = function(pool){
      var out = prevView(pool) || [];
      for(var i=0;i<out.length;i++){
        if(String(out[i].id) === pick){
          if(i > 0) out.unshift(out.splice(i,1)[0]);
          break;
        }
      }
      return out;
    };
  }

  var key=resolve(data.bundles, wanted());
  if(key && typeof SF.setTier==='function') SF.setTier(key);
  else if(pick && typeof SF.renderBundles==='function') SF.renderBundles();

  /* Keep the address bar honest as the shopper switches tabs. */
  if(typeof SF.setTier==='function' && window.history && history.replaceState){
    var orig=SF.setTier;
    SF.setTier=function(k){
      orig(k);
      var b=(data.bundles||{})[k];
      if(!b) return;
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('bundle', slug(b.label).replace(/-kd$/,''));
        history.replaceState({}, '', u.toString());
      }catch(e){}
    };
  }

  /* Select it once its card is on the page. It should be first now, so this
     normally succeeds on the first attempt; the retries cover a tier whose
     pool is still being fetched. */
  if(pick){
    var tries = 0;
    (function attempt(){
      var card = grid.querySelector('[data-vid="' + pick + '"]');
      if(card){
        if(card.getAttribute('data-picked') !== '1' && typeof SF.togglePick === 'function'){
          SF.togglePick(Number(pick));
        }
        return;
      }
      if(++tries < 20) setTimeout(attempt, 100);
    })();
  }
});
})();